import React from 'react';
import styles from './PageStyles.module.css';
import cardStyles from './MainPage.module.css';
import { motion } from 'framer-motion';

const statusGridVariants = {
    hidden: { opacity: 1 },
    show: {
        opacity: 1,
        transition: {
            staggerChildren: 0.1,
            delayChildren: 0.3,
        },
    },
};

const statusCardVariants = {
    hidden: { opacity: 0, y: 30 },
    show: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } },
};

const projectStatuses = [
    { name: "YEP & Link", siteUrl: "https://lab5-efba9.firebaseapp.com/", statusLabel: "Запущен (Beta)", description: "Основные функции реализованы. Идет активный сбор обратной связи для улучшения интерфейса и добавления новых возможностей. Присоединяйтесь к тестированию!", progressDetails: "Цель на следующий квартал: Интеграция с YEP API." },
    { name: "YEP & Sell", siteUrl: "https://yepandsell-55d88.web.app/", statusLabel: "Ранняя Beta-версия (v1)", description: "Платформа доступна в формате первой бета-версии. Основной функционал для сделок реализован, ведется активная работа над улучшением стабильности и пользовательского опыта.", progressDetails: "Полноценный бета-запуск с расширенным функционалом ожидается к концу лета 2025 года." },
    { name: "YEP & Boost", siteUrl: null, statusLabel: "В активной разработке (Alpha)", description: "Разработаны и тестируются ключевые механики прокачки для нескольких популярных игр. Особое внимание уделяется безопасности аккаунтов.", progressDetails: "Ожидаемый запуск закрытого Alpha-тестирования: Q3 2025." },
    { name: "YEP & Set", siteUrl: null, statusLabel: "Планирование и дизайн", description: "Завершено формирование концепции и MVP. Прорабатывается дизайн интерфейсов и пользовательский опыт для сервиса креативных решений.", progressDetails: "Начало разработки: Q4 2025." },
    { name: "YEP & Coding", siteUrl: null, statusLabel: "В разработке (Pre-Alpha)", description: "Создается базовая инфраструктура для API и SDK. Готовится техническая документация для разработчиков и партнеров.", progressDetails: "Публикация первой версии API: Q1 2026." },
    { name: "YEP & Future", siteUrl: null, statusLabel: "Исследование и концептуализация", description: "Изучаются перспективные направления, включая AI-инструменты для автоматизации и персонализации, а также децентрализованные технологии.", progressDetails: "Формирование дорожной карты: конец 2025." },
    { name: "RethBLOOD", isExternal: true, siteUrl: null, statusLabel: "В разработке (долгосрочный)", description: "Внешний проект. Информация о текущем статусе ограничена. Разработка ведется независимой командой.", progressDetails: "Предположительный горизонт запуска: ~2030 год (через 5 лет от текущей даты)." },
];

const pageContainerVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: {duration: 0.3} }
}
const titleVariants = {
    hidden: {opacity:0, y: -20},
    visible: {opacity:1, y:0, transition:{duration:0.5, delay: 0.1}}
}

const StatusPage = () => {
    return (
        <motion.div
            className={styles.pageContainer}
            variants={pageContainerVariants}
            initial="hidden"
            animate="visible"
        >
            <motion.h1
                className={styles.pageTitle}
                variants={titleVariants}
            >
                Статус Проектов YEP
            </motion.h1>

            <motion.div
                className={cardStyles.projectsGrid}
                variants={statusGridVariants}
                initial="hidden"
                animate="show"
            >
                {projectStatuses.map((project, index) => (
                    <motion.div
                        key={index}
                        className={`${cardStyles.projectCard} ${styles.statusCard}`}
                        variants={statusCardVariants}
                    >
                        <h4>
                            {project.name.includes('&') ? (
                                <>
                                    {project.name.split('&')[0]}
                                    <span className={cardStyles.ampersand}>&</span>
                                    {project.name.split('&')[1]}
                                </>
                            ) : (
                                project.name
                            )}
                            {project.isExternal && <span className={styles.externalProjectTag}>(Внешний)</span>}
                        </h4>
                        <p className={styles.statusLabel}><strong>Текущий статус:</strong> {project.statusLabel}</p>
                        <p>{project.description}</p>
                        {project.progressDetails && <p className={styles.progressDetails}><strong>Планы и прогресс:</strong> {project.progressDetails}</p>}
                        {project.siteUrl && (
                            <button className={cardStyles.projectCardButton} onClick={() => window.open(project.siteUrl, '_blank')}>
                                Перейти на сайт
                            </button>
                        )}
                    </motion.div>
                ))}
            </motion.div>
        </motion.div>
    );
};

export default StatusPage;